// test2599
(2599 && 0);
